/**
 * Application page constants
 *
 * Centralized location for constants used across application pages and components.
 */

/**
 * The application title used across all application pages.
 * Used in the workflow layout, application status page, digital signature modal, and other
 * application pages.  ENOVA_APPLICATION_TITLE is used in signature attestation and
 * shared for computing hashes.
 */
export {
  ENOVA_APPLICATION_TITLE as APPLICATION_TITLE,
  ENOVA_APPLICATION_TITLE,
  getAttestationDisclaimerText,
} from '@access-cms/shared-constants';

/**
 * Search parameter toggle for enabling a local test path that skips
 * application initialization fetch and starts from an empty workflow state.
 */
export const APPLICATION_TEST_MODE_PARAM = 'testMode';

export const USER_CATEGORY = {
  DISPLAY: 'Contractor',
  VALUE: 'contractor',
} as const;
